// extracted by mini-css-extract-plugin
module.exports = {"text-underline":"common_text-underline__iySxm","horizontal-menu":"common_horizontal-menu__BzW4j"};